import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import IndustriesSection from './components/IndustriesSection';
import ServicesSection from './components/ServicesSection';
import DeRiskingSection from './components/DeRiskingSection';
import NewsAndSupplierSection from './components/NewsAndSupplierSection';
import CTASection from './components/CTASection';

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      name: 'MAX-Sourcing',
      url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
      logo: {
        '@type': 'ImageObject',
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/logo.png`,
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1-819-923-0918',
        contactType: 'customer service',
        email: 'contact@MAX-Sourcing.com',
        areaServed: ['US', 'CA', 'GB', 'CN', 'IN'],
        availableLanguage: 'English',
      },
      sameAs: [],
      description:
        'MAX-Sourcing delivers global pharmaceutical sourcing, fine chemicals APIs, and cGMP-compliant supply chain solutions serving Food, Pharmaceutical, Industrial, and Mining sectors.',
    },
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website`,
      url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
      name: 'MAX-Sourcing',
      publisher: {
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization`,
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/products?search={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#webpage`,
      url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
      name: 'MAX-Sourcing | Global Pharmaceutical Sourcing & Fine Chemicals',
      description:
        'MAX-Sourcing delivers global pharmaceutical sourcing, fine chemicals APIs, and cGMP-compliant supply chain solutions.',
      inLanguage: 'en',
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website` },
      about: { '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#organization` },
      dateModified: '2026-04-07',
      translationOfWork: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr#webpage`,
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr`,
        inLanguage: 'fr',
      },
      workTranslation: {
        '@type': 'WebPage',
        '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr#webpage`,
        url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr`,
        inLanguage: 'fr',
      },
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    document.title = 'MAX-Sourcing | Global Pharmaceutical Sourcing & Fine Chemicals';
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(HOME_SCHEMA);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <main>
      <HeroSection />
      <AboutSection />
      <IndustriesSection />
      <ServicesSection />
      <DeRiskingSection />
      <NewsAndSupplierSection />
      <CTASection />
    </main>
  );
}
